var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "id": _vm.id,
      "title": _vm.title,
      "centered": _vm.centered,
      "hide-footer": _vm.hideFooter,
      "hide-header-close": _vm.hideHeaderClose,
      "no-close-on-backdrop": _vm.noCloseOnBackdrop,
      "title-class": "text-center"
    },
    on: {
      "close": _vm.closeHandler
    }
  }, [_c('div', {
    staticClass: "d-block text-center"
  }, [_vm._t("body")], 2), _c('div', {
    staticClass: "mt-3 d-flex flex-row justify-content-center align-items-center"
  }, [_vm._t("row-buttons")], 2)]);

}
var staticRenderFns = []

export { render, staticRenderFns }